// utils/toggleClass.ts

/**
 * Toggles a specified CSS class on a given HTML element.
 * @param {HTMLElement} elems - The target HTML elements to toggle the class on.
 * @param {string} classNames - The CSS classes to toggle from an array.
 */
export function toggleClass(elems: HTMLElement[], classNames: string[]): void {
	elems.forEach((elem) => {
		classNames.forEach((className) => {
			elem.classList.toggle(className);
		});
	});
}
